import { axiosBase, errorHandler } from "./axios";

const listUsers = (input: any) => {
  return axiosBase.post("/api/v1/users/listUser", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const inviteUser = (input: any) => {
  return axiosBase.post("/api/v1/users/inviteUser", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};
const editUser = (input: any) => {
  const { id, payload, ...rest } = input;
  return axiosBase.put(`/api/v1/users/edit/${id}`, payload ?? rest)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};
const viewUser = (payload: any) => {
  
    return axiosBase
        .get(`/api/v1/users/view/`, {
            params: {
                id: typeof payload === "string" ? payload : payload.id,
                ...(typeof payload === "object"
                    ? {
                          ...payload
                      }
                    : null),
            },
        })
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const getKycEncryptedDocument = (userId: string) => {
  console.log("Fetching KYC document for userId:", userId);
  return axiosBase
    .get(`/api/v1/account/kyc-document/${userId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const requestKycDocumentOtp = (userId: string) => {
  return axiosBase
    .post(`/api/v1/account/kyc-document/${userId}/send-otp`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const verifyKycDocumentOtpAndFetch = (userId: string, otp: string) => {
  return axiosBase
    .post(`/api/v1/account/kyc-document/${userId}/verify-otp`, { otp })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const deleteUserRequest = (input: any) => {
  return axiosBase.post("/api/v1/users/deleteRequest", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const processDeleteRequest = (input: any) => {
  return axiosBase.post("/api/v1/users/processDeleteRequest", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const listDeleteRequests = (input: any) => {
  return axiosBase.post("/api/v1/users/listDeleteRequests", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const revokeUser = (input: any) => {
  return axiosBase.post("/api/v1/users/revokeUser", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const submitUpdateRequest = (input: any) => {
  return axiosBase.post("/api/v1/users/update-request", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const processUpdateRequest = (input: any) => {
  return axiosBase.post("/api/v1/users/update-request/action", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const listUpdateRequests = (input: any) => {
  return axiosBase.post("/api/v1/users/update-request/list", input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const userService = {
  listUsers,
  inviteUser,
  editUser,
  viewUser,
  getKycEncryptedDocument,
  requestKycDocumentOtp,
  verifyKycDocumentOtpAndFetch,
  deleteUserRequest,
  processDeleteRequest,
  listDeleteRequests,
  revokeUser,
  submitUpdateRequest,
  processUpdateRequest,
  listUpdateRequests,
};
